import $ from 'jquery';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";

$(document).ready(function() {

    $().fancybox({
        selector : '.slick-slide:not(.slick-cloned)',
        hash     : false
    });

    /* MATCH HEIGHT EQUAL HEIGHT

    $('.matchHeight').matchHeight();
     */

    /* SWITCHER
    $('.toggle-btn').click(function() {
        $(this).parent().toggleClass('active').siblings().removeClass('active');
        //$(this).parent().find('.single_switcher__active').toggleClass('active').siblings().removeClass('active');
    });
     */

    /* AOS ANIMATION FUNCTION

    $(function() {
        AOS.init();
    });
     */


});